import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';
import Reveal from '@/components/Reveal';

export default function Quality() {
  const { t } = useLang();
  return (
    <div data-testid="quality-page">
      <section className="mm-section dark grain" style={{ paddingTop: 72, position: 'relative', overflow: 'hidden' }}>
        <div className="container-mm">
          <div className="eyebrow">{t.home.quality_eyebrow}</div>
          <h1 style={{ fontSize: 'clamp(48px, 6vw, 96px)', marginTop: 16, color: 'var(--mm-ivory)' }}>{t.quality.title}</h1>
          <p style={{ fontSize: 18, color: 'rgba(246,242,235,0.7)', marginTop: 24, maxWidth: 720 }}>
            {t.home.quality_lead}
          </p>

          <div className="mm-features" style={{ marginTop: 56 }}>
            {t.quality.items.map((q, i) => (
              <Reveal key={i} delay={i * 80} className="mm-col wide">
                <div className="mm-feature" style={{ height: '100%' }} data-testid={`quality-item-${i}`}>
                  <div className="icon-wrap"><ShieldCheck size={20} /></div>
                  <h3>{q.t}</h3>
                  <p>{q.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
